namespace GeniuzPOS.Purchase {
    export interface PoApprovalTranForm {
        ApprGroupCode: Serenity.StringEditor;
        ApproveFg: Serenity.EnumEditor;
        AppActiveFg: Serenity.EnumEditor;
    }

    export class PoApprovalTranForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoApprovalTran';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoApprovalTranForm.init)  {
                PoApprovalTranForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;

                Q.initFormType(PoApprovalTranForm, [
                    'ApprGroupCode', w0,
                    'ApproveFg', w1,
                    'AppActiveFg', w1
                ]);
            }
        }
    }
}
